import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { areaCards } from '../../data/om-mig-data';
export function OmMigSummary() {
  return <section className="py-16 md:py-24 px-6 bg-ink text-white" data-id="element-146">
      <div className="max-w-4xl mx-auto" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-14" data-id="element-148">
          <span className="text-terracotta font-medium tracking-widest text-xs uppercase mb-3 block" data-id="element-149">
            Kort om Peter
          </span>
          <h2 className="text-2xl md:text-3xl font-light text-white leading-relaxed mb-6" data-id="element-150">
            <span className="text-terracotta font-medium" data-id="element-151">
              En röd tråd genom allt jag gör
            </span>{' '}
            är att skapa rörelse där det har stannat av.
          </h2>
          <p className="text-white/70 text-lg leading-relaxed max-w-2xl" data-id="element-152">
            Jag har varit VD, lett förändringsarbete i komplexa miljöer och
            coachat chefer som behöver tänka klarare. Jag kombinerar
            affärsanalys med praktiskt genomförande — och jobbar alltid nära
            verksamheten, inte från sidlinjen.
          </p>
          <p className="text-white/70 text-lg leading-relaxed max-w-2xl mt-4" data-id="element-153">
            Mitt företag driver och äger jag själv, och många leveranser gör jag
            på egen hand. Men jag jobbar också med två andra
            förändringskonsulter i nätverket{' '}
            <a href="https://www.be-brave.se" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:text-terracotta/80 underline underline-offset-2 transition-colors" data-id="element-154">
              Be Brave
            </a>
            . Tillsammans har vi en ännu större bredd — framför allt inom
            remote- och distanslärande, som är en av våra specialiteter.
          </p>

          {/* Colleague Photos */}
          <motion.div className="grid grid-cols-3 gap-4 mt-8 max-w-3xl" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-155">
            <div className="aspect-[4/3] overflow-hidden rounded-xl border border-white/10" data-id="element-156">
              <img src="https://cdn.magicpatterns.com/uploads/ubhKRu7WFUmEthdJHnP7L1/IMG_0932.jpg" alt="Peter och Johan" className="w-full h-full object-cover" data-id="element-157" />
            </div>
            <div className="aspect-[4/3] overflow-hidden rounded-xl border border-white/10" data-id="element-158">
              <img src="https://cdn.magicpatterns.com/uploads/d4MncF348P24Pp4YN1Vrtx/IMG_0935.jpg" alt="Peter och Johan i arbete" className="w-full h-full object-cover" data-id="element-159" />
            </div>
            <div className="aspect-[4/3] overflow-hidden rounded-xl border border-white/10" data-id="element-160">
              <img src="https://cdn.magicpatterns.com/uploads/hSBjTCHEahiYTP9iwJgobr/OriginalPhoto-724603035.63585.jpg" alt="Karolin" className="w-full h-full object-cover" data-id="element-161" />
            </div>
            <p className="col-span-3 text-white/50 text-sm italic mt-1" data-id="element-162">
              Tillsammans med Johan och Karolin i Be Brave.
            </p>
          </motion.div>
        </motion.div>

        {/* Three area cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10" data-id="element-163">
          {areaCards.map((area, i) => <motion.div key={area.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} data-id="element-164">
              <Link to={area.href} className="block bg-white/5 rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-all group h-full" data-id="element-165">
                <span className={`text-2xl font-light leading-none block mb-3 ${area.color === 'terracotta' ? 'text-terracotta/40' : 'text-sage/40'}`} data-id="element-166">
                  {area.num}
                </span>
                <h3 className="text-white font-medium text-base mb-2" data-id="element-167">
                  {area.title}
                </h3>
                <p className="text-white/50 text-sm leading-relaxed mb-4" data-id="element-168">
                  {area.desc}
                </p>
                <span className={`flex items-center text-sm font-medium ${area.color === 'terracotta' ? 'text-terracotta' : 'text-sage'}`} data-id="element-169">
                  Läs mer
                  <ArrowRight className="w-3.5 h-3.5 ml-1.5 group-hover:translate-x-1 transition-transform" data-id="element-170" />
                </span>
              </Link>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-white/40 text-sm italic text-center" data-id="element-171">
          Gemensamt för alla tre: en dag i veckan, nära verksamheten, med fokus
          på det som faktiskt gör skillnad.
        </motion.p>
      </div>
    </section>;
}